import React from 'react';
import { Animate } from 'react-move';
import cx from 'classnames';
import * as d3 from 'd3';
import { easeCubicInOut } from 'd3-ease';
import Card from '../Card';
import MobileDetect from 'mobile-detect';
import MediaQuery from 'react-responsive';

const md = new MobileDetect(window.navigator.userAgent);
const isMobile = !!md.mobile();

export default class ControlRacks extends React.Component {
  state = {
    appear: false,
    expand: true
  };
  imgFolder = './assets/img/';

  componentDidUpdate(prevProps) {
    if (prevProps.step < 2 && this.props.step >= 2) {
      this.setState({ appear: true });
    }
    if (prevProps.step >= 2 && this.props.step < 2 && !this.props.scrolling) {
      // this.setState({ appear: false });
    }
  }

  racks = [
    {
      title: 'hybrid',
      img: 'thumbs/configure_both.png',
      paragraph: (
        <div>
          <div>
            Depending on your space needs, we can accommodate a hybrid solution
            between two-tier and vertical racks. This option optimizes the
            configuration based on space requirements.
          </div>
        </div>
      )
    },
    {
      title: 'two-tier',
      img: 'thumbs/Two_Tier.png',
      paragraph:
        'The Double Docker™ takes high-density parking to the next level. Accommodating almost all types of bicycles, the Double Docker™ also accommodates demographics that need lift assistance.'
    },
    {
      title: 'vertical',
      img: 'thumbs/Vertical.png',
      paragraph: (
        <div>
          The Offset
          <span
            style={{
              fontSize: '10px',
              lineHeight: '20px',
              verticalAlign: 'top'
            }}
          >
            ®{' '}
          </span>
          Vertical Bike Rack offers the country’s only ultra space-saving dual
          unit bicycle rack, securing two bicycles within 6 – 8 inches of space.
        </div>
      )
    }

    // {
    //   title: 'let the experts decide',
    //   img: 'thumbs/placeholder_results.png',
    //   paragraph:
    //     'Our team of experts is happy to work directly with you to determine the best way to store your bikes.'
    // }
  ];

  get filterRacks() {
    const {
      parameters: { configuration, uxPath }
    } = this.props;

    const isRiderFriendly = configuration === 'Rider Friendly';
    const isBalanced = configuration === 'Balanced';

    return this.racks
      .map((d, i) => {
        return {
          ...d,
          disabled:
            (uxPath !== 'dimensions' && d.title === 'let the experts decide') ||
            isRiderFriendly ||
            (isBalanced &&
              (d.title === 'let the experts decide' || d.title === 'hybrid'))
        };
      })
      .filter((el) => el);
  }

  headerHeight = 40;
  render() {
    const { racks, imgFolder, filterRacks } = this;
    const {
      handleScrollIn,
      handleScrollOut,
      handleStepSet,
      parameters: { configuration, rack: gRack },
      disableWaypoint
    } = this.props;
    const { appear, expand } = this.state;

    const activeRack = racks.find((r) => r.title === gRack);

    return configuration !== 'Rider Friendly' ? (
      <Card
        appear={appear}
        handleStepSet={handleStepSet}
        stepIndex={2}
        disableWaypoint={disableWaypoint}
        step={this.props.step}
        expand={expand}
        handleScrollIn={this.props.step === 2 ? handleScrollIn : () => {}}
        handleScrollOut={this.props.step === 1 ? handleScrollOut : () => {}}
        config={configuration}
        header={'Rack Options'}
        helperText={`Some projects will call out a specific rack style, such as
        vertical hanging racks or two-tier systems. It is important to
        know which racks are specified on your projects. If you are
        not working with specific requirements, use our Hybrid option
        to get the most space efficient and max density option.`}
        content={
          isMobile && window.innerWidth < 650 ? (
            <div
              className={cx({
                'control-layout-racks': true,
                active: false,
                disabled: false,
                single: true
              })}
              onClick={() => {
                // this.handleScrollIn();
                // !disabled && this.props.actions.parameterRack(activeRack.title);
              }}
            >
              <div className='card-selections'>
                {racks.map((r) => {
                  return (
                    <div
                      key={r.title}
                      onClick={(e) => {
                        e.stopPropagation();
                        !r.disabled &&
                          this.props.actions.parameterRack(r.title);
                      }}
                      className={cx({
                        'card-selection': true,
                        active: r.title === gRack,
                        disabled: r.disabled
                      })}
                    >
                      {r.title}
                    </div>
                  );
                })}
              </div>
              <div className='subheader'>
                {activeRack.title === 'hybrid'
                  ? 'hybrid (recommended)'
                  : activeRack.title}
              </div>
              <div className='control-layout-racks-img'>
                <img src={`${imgFolder}${activeRack.img}`} />
              </div>
              <div className='card-paragraph'>{activeRack.paragraph}</div>
              {activeRack.disabled ? (
                <div className='disabled-notice'>[disabled for selection]</div>
              ) : null}
              {racks.map((r) => {})}
            </div>
          ) : (
            filterRacks.map((rack) => {
              const { title, img, paragraph } = rack;
              const disabled = rack.disabled;
              return (
                <div
                  className={cx({
                    'control-layout-racks': true,
                    active: title === gRack,
                    disabled
                  })}
                  key={title}
                  style={{ maxWidth: '33%' }}
                  onClick={() => {
                    // this.handleScrollIn();
                    !disabled && this.props.actions.parameterRack(title);
                  }}
                >
                  <div className='subheader'>
                    {title === 'hybrid' ? 'hybrid (recommended)' : title}
                  </div>
                  <div className='control-layout-racks-img'>
                    <img src={`${imgFolder}${img}`} />
                  </div>
                  <div className='card-paragraph'>{paragraph}</div>
                  {disabled ? (
                    <div className='disabled-notice'>
                      [disabled for selection]
                    </div>
                  ) : null}
                </div>
              );
            })
          )
        }
      />
    ) : (
      <div />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Controls/ControlRacks/index.js